<template>
  <div class="text-xs-center">
      <v-form ref="taskForm" v-model="valid">
        <v-layout wrap justify-center align-center>
          <v-flex xs12>
          <!-- :rules="rules" -->
          <v-autocomplete
            ref="tasks"
            @keyup.native="keyupTasksSystem"
            @change="selectTask"
            @click="click"
            @blur="blur"
            :no-data-text="loadingTasksSystem ? 'Carregando...' : 'Sem registros'"
            :rules="rules"
            :search-input.sync="search"
            :loading="loadingTasksSystem"
            :disabled="disabled || disabledTask"
            v-model="selectedTask"
            :items="items"
            :filter="customFilter"
            clearable
            :label="label ? label : 'Selecione uma tarefa'"
            item-value="id"
            item-text="id_text"
            style="margin-top: 0 !important; padding-top: 6px !important;"
          >
            <template v-slot:selection="data">
              <div style="margin-top: 10px;">
                 {{data.item.id_text}} 
              </div>
            </template>
            <template v-slot:item="data">
              <template v-if="data.item.id_text === 'line'">
                <v-progress-linear :indeterminate="true"></v-progress-linear>
              </template>
              <!-- // foi removido o mostrar mais pois qundos elecionava ele o quadro de tarefas desaparecia -->
              <!-- <template v-else-if="data.item.id === 'showMore'">
                <div class="text-xs-center show-more">
                  <v-progress-circular v-if='loadingMoreTasks' :size="20" :width="3" indeterminate color="primary"></v-progress-circular>
                  <span v-else><strong>Mostrar mais</strong></span>
                </div>
              </template> -->
              <template v-else>
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.id_text"></v-list-tile-title>
                </v-list-tile-content>
              </template>
            </template>
          </v-autocomplete>
        </v-flex>
      </v-layout>
    </v-form>
  </div>
</template>

<script>
  // desabilita para poder fazer a verificação sem precisar ter a tipagem certa
  /* eslint-disable eqeqeq */
  import general from '../../mixin/general'
  import rules from './../../mixin/rules'
  import access from './../../mixin/access'

  export default {
    name: 'PTasksIllis',
    mixins: [access, general, rules],
    props: {
      value: {},
      disabled: {
        type: Boolean
      },
      label: {},
      rules: {}
    },
    data () {
      return {
        basePath: process.env.API,
        loadingTasksSystem: false,
        loadingMoreTasks: false,
        disabledTask: true,
        tasksSystem: [],
        valid: false,
        items: [],
        qtdMoreTask: 1,
        setKeyup: null,
        search: '',
        selectedTask: []
      }
    },
    mounted () {
      this.loadingTasksSystem = true
      // Já busca 50 primeiras tarefas
      this.getTasksSystem()
    },
    methods: {
      click () {
        this.$emit('click')
      },
      focus () {
        this.$nextTick(() => this.$refs.tasks.focus())
      },
      validate () {
        return (this.$refs.taskForm && this.$refs.taskForm.validate())
      },
      blur () {
        // ao sair do campo zera o search portanto deve pesquisar os valores novamente
        this.keyupTasksSystem()
      },
      keyupTasksSystem () {
        clearTimeout(this.setKeyup)
        this.loadingTasksSystem = true
        this.mountItem()
        this.setKeyup = setTimeout(() => {
          this.qtdMoreTask = 1
          this.getTasksSystem()
        }, 2000)
      },
      getTasksSystem () {
        this.loadingMoreTasks = true
        let permission = false
        permission = this.$auth.user()['admin']
        this.$http.get(`api/get_tasks_illis?qtd=${this.qtdMoreTask || 1}&search=${this.search || ''}&permission=${permission}`).then((res) => {
          this.tasksSystem = res.body
          this.loadingMoreTasks = false
          this.loadingTasksSystem = false
          this.disabledTask = false
          this.mountItem()
        })
      },
      selectTask (val) {
        setTimeout(() => {
          // let showMore = false
          if (typeof val === 'undefined') {
            this.selectedTask = null
          }
          // if (showMore) {
          // this.qtdMoreTask++
          // this.getTasksSystem()
          // } else {
          // MOnta novamente a lista de itens
          this.$emit('input', this.selectedTask)
          this.mountItem()
          this.search = ''
          // }
        }, 10)
      },
      // Usado para não usar o filtro do componente autocomplete
      customFilter (item, queryText, iText) {
        let itemText = item.id_text
        const hasValue = val => val != null ? val : ''
        const text = hasValue(itemText).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        const search = hasValue(this.search).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        return text.indexOf(search) > -1 || item['type'] == 0
      },
      mountItem () {
        this.items = []
        // foi incluido o id: 0 para eles passarem pelo filtro e mostrar quando o usuário filtra
        if (this.loadingTasksSystem) Array.prototype.push.apply(this.items, [{ id: 'line', type: 0, id_text: 'line' }])
        // CAso tenha valores selecionados que devido ao filtro não estão na lista, adiciona-los manualmente
        if (this.selectedTask !== null) {
          if ((typeof this.selectedTask) === 'object' && this.selectedTask.hasOwnProperty('id')) {
            if (this.selectedTask.company_id !== this.company_id && !this.tasksSystem.some((val) => { return this.selectedTask.id === val.id })) {
              this.tasksSystem.unshift(this.selectedTask)
            }
          }
        }
        Array.prototype.push.apply(this.items, JSON.parse(JSON.stringify(this.tasksSystem || [])))
        // if ((this.qtdMoreTask * 25) <= this.tasksSystem.length) {
        //   Array.prototype.push.apply(this.items, [{ id: 'showMore', type: 0, id_text: 'Mostrar mais' }])
        // }
        Array.prototype.push.apply(this.items, [{ id: 'search', type: 0, header: 'Digite para encontrar tarefas' }])
      }
    },
    watch: {
      // caso a tarefa de fora sejá alterado, tbm alterar o do pTaskIllis
      value: {
        immediate: true,
        handler (val, oldVal) {
          if (val != this.selectedTask) {
            this.selectedTask = val
            this.mountItem()
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/PTasksIllis.vue